import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1ed85f2f&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed85f2f",
  null
  
)

export default component.exports